export const SCRIPT_MARKER = "[SCRIPT_READY]";

/** Concatenated text parts of a UI message. */
export const textOf = (m: { parts?: Array<{ type: string; text?: string }> }) =>
  (m.parts ?? []).filter((p) => p.type === "text").map((p) => p.text ?? "").join("");

/** Removes the marker; returns the full script plus a ~6-line preview and the remainder (to blur). */
export const splitScript = (raw: string, previewLines = 6) => {
  const full = raw.trimStart().replace(SCRIPT_MARKER, "").replace(/^\s*\n/, "").trim();
  const lines = full.split("\n");
  let count = 0;
  let cut = lines.length;
  for (let i = 0; i < lines.length; i++) {
    if (lines[i].trim()) count++;
    if (count >= previewLines) { cut = i + 1; break; }
  }
  return { full, preview: lines.slice(0, cut).join("\n"), rest: lines.slice(cut).join("\n") };
};
